module.exports = __webpack_public_path__ + "static/media/creature-arm-right.9299d314.svg";